<template>
 <div v-if="hasRole(roles.RW_IMOB_CADASTROS) || hasRole(roles.RW_REAL_ESTA_ADMIN)">
    <div v-if="!flDetails" class="d-flex">
      <div class="col-md-3">
         <Searchenterprise @filter="changeDataFilter"></Searchenterprise>
      </div>
      <div class="col-md-9">
         <Tableenterprise :dataFilter="dataFilter" @edit="showDetails"></Tableenterprise>
      </div>
  </div>
  <Detailsenterprise :data="dataDetails" :id="id" v-if="flDetails"></Detailsenterprise>
 </div>
</template>

<script>
import Enterprise from './enterprise'
export default Enterprise
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/private/realestate/enterprise/enterprise.vue